import { useState, useEffect } from "react";

const MOBILE_BREAKPOINT = 600;

export const useIsMobile = () => {
    const [isMobile, setIsMobile] = useState(window.innerWidth < MOBILE_BREAKPOINT);

    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth < MOBILE_BREAKPOINT);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return isMobile;
}

export const Col = props => {
    const isMobile = useIsMobile();
    return (
        <div
            ref={props.reference}
            onClick={props.onClick}
            onMouseEnter={props.onMouseEnter}
            onMouseDown={props.onMouseDown}
            onMouseLeave={props.onMouseLeave}
            onDrag={props.onDrag}
            draggable={props.draggable}
            onDragStart={props.onDragStart}
            onDragEnd={props.onDragEnd}
            className={props.className}
            style={{display: 'flex', flex: 1, flexDirection: 'column', alignItems:'center', justifyContent:'center', ...props.style, ...(isMobile ? props.mobileStyle : {})}}>
            {props.children}
        </div>
    )
}

export const Row = props => {
    const isMobile = useIsMobile();
    return (
        <div
            ref={props.reference}
            onClick={props.onClick}
            onMouseEnter={props.onMouseEnter}
            onMouseDown={props.onMouseDown}
            onMouseLeave={props.onMouseLeave}
            onDrag={props.onDrag}
            draggable={props.draggable}
            onDragStart={props.onDragStart}
            onDragEnd={props.onDragEnd}
            className={props.className}
            style={{display: 'flex', flex: 1, flexDirection: 'row', alignItems:'center', justifyContent:'center', ...props.style, ...(isMobile ? props.mobileStyle : {})}}>
            {props.children}
        </div>
    )
}